import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { tours, siteInfo } from '../data/mock';
import { Button } from './ui/button';
import { Clock, Check, ArrowRight } from 'lucide-react';

const ToursSection = () => {
  const { language, t } = useLanguage();

  return (
    <section id="tours" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <span className="text-teal-600 font-medium text-sm uppercase tracking-wider">
            {language === 'en' ? 'Explore Bali' : 'Explorer Bali'}
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-stone-800 mt-3 mb-4">
            {t.tours.title}
          </h2>
          <p className="text-stone-600 max-w-2xl mx-auto text-lg">
            {t.tours.subtitle}
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {tours.map((tour) => (
            <div
              key={tour.id}
              className="group bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300 border border-stone-100"
            >
              <div className="relative h-56 overflow-hidden">
                <img
                  src={tour.image}
                  alt={tour[language].name}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute top-4 left-4 bg-white/95 backdrop-blur-sm px-3 py-1.5 rounded-full">
                  <span className="text-sm font-semibold text-teal-600">
                    {t.tours.from} ${tour.price}
                  </span>
                </div>
              </div>

              <div className="p-6">
                <div className="flex items-center gap-2 text-stone-500 text-sm mb-3">
                  <Clock className="w-4 h-4" />
                  <span>{tour.duration}</span>
                </div>

                <h3 className="text-xl font-semibold text-stone-800 mb-3 group-hover:text-teal-600 transition-colors">
                  {tour[language].name}
                </h3>

                <p className="text-stone-600 text-sm mb-4 line-clamp-2">
                  {tour[language].description}
                </p>

                <div className="mb-5">
                  <p className="text-xs font-medium text-stone-500 uppercase tracking-wider mb-2">
                    {t.tours.highlights}
                  </p>
                  <div className="flex flex-wrap gap-2">
                    {tour[language].highlights.slice(0, 3).map((highlight, idx) => (
                      <span
                        key={idx}
                        className="inline-flex items-center gap-1 text-xs bg-stone-100 text-stone-600 px-2 py-1 rounded-md"
                      >
                        <Check className="w-3 h-3 text-teal-500" />
                        {highlight}
                      </span>
                    ))}
                  </div>
                </div>

                <a
                  href={`${siteInfo.whatsappLink}?text=${encodeURIComponent(
                    language === 'en'
                      ? `Hi, I'm interested in the ${tour.en.name} tour.`
                      : `Bonjour, je suis intéressé(e) par l'excursion ${tour.fr.name}.`
                  )}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Button className="w-full bg-stone-900 hover:bg-teal-600 text-white group/btn transition-colors">
                    {t.tours.bookNow}
                    <ArrowRight className="w-4 h-4 ml-2 group-hover/btn:translate-x-1 transition-transform" />
                  </Button>
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ToursSection;